<iframe
  [src]="kycUrl"
  class="iframe-kyc"
  width="100%"
  height="100%"
  allow="camera; microphone"
  allowfullscreen
></iframe>
